import { Grid, Typography, FormControl, InputLabel, IconButton, OutlinedInput, InputAdornment } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { makeStyles } from "@material-ui/core/styles";
import QueueSelectConnection from "../Queue/queueSelectConnection";
import MultiSelect from "../InputStyled/multiselect";
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  connectionFilter: {
    padding: "0 0 0 10px",
    "& span:nth-of-type(1)": {
        justifyContent: "flex-start",
        "& span:nth-of-type(1)": {
            position: "absolute",
            marginLeft: "0",
            marginRight: "0",
            right: "5px"
        }
      },
  },
  multiSelectFilter: {
    padding: "0 0 0 10px",
    width: "100%",
    height: "40px",
    lineHeight: "40px",
    "& span:nth-of-type(1)": {
        justifyContent: "flex-start",
        textTransform: "capitalize",
        textAlign: "left",
        "& svg:nth-of-type(1)": {
            position: "absolute",
            marginLeft: "0",
            marginRight: "0",
            right: "5px"
        }
      },
    },
    userState: {
        padding: '0',
        borderRadius: '100%',
        marginRight: '5px',
        boxShadow: 'box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;background-color: rgb(66, 66, 66)',
        height: '10px',
        width: '10px',
        display: 'inline-block',
    }
}));

const TicketManagementFilters = ({ selectedsConnectionsAndQueues, onSelectConnectionsAndQueues, users, onSelectedUsers, selectedUsers, userStatus, onSelectedUserStatus, selectedUserStatus, assigneds, onSelectAssigned, selectedAssigned, ticketStatus, selectedTicketStatus, onSelectTicketStatus, tags, selectedTags, onSelectedTags, handleSearchParam, searchParam, user }) => {

    const classes = useStyles();
    const [inputText, setInputText] = useState("");

    const handleSearch = () => {
        if (inputText.length == 0 || inputText.length > 3) {
            handleSearchParam(inputText);
        }
    }

    const isOnline = (usr) => {
        let statusColor;
        let key = new Date().getTime();
        let check = usr.state;
        let name = usr.name;

        switch (String(check).toLocaleLowerCase()) {
            case 'online':
                statusColor = '#4caf50';
                break;
            case 'out':
                statusColor = '#ff9800';
                break;
            default:
                statusColor = '#f44336';
                break;
        }

        return (
            <>
                <Typography
                    component="span"
                    key={key}
                    className={classes.userState}
                    style={{ background: statusColor }}
                />
                {name}
            </>
        );
    }

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">{i18n.t("ticketManagement.filters.title")}</Typography>
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography style={{ marginBottom: "5px" }}>{i18n.t("ticketManagement.filters.text")}</Typography>
                    <FormControl 
                        variant="outlined"
                        style={{
                            width: "100%"
                        }}
                    >
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type="text"
                            value={inputText}
                            style={{
                                height: "35px",
                                lineHeight: "35px",
                            }}
                            onChange={(e) => {
                                const str = String(e.target.value).toLocaleLowerCase();
                                setInputText(str);
                            }}
                            onKeyUp={(e) => {
                                const key = e.charCode || e.keyCode || 0;
                                const str = e.target.value;
                                if (key === 13 || (str == "" && searchParam != "")) {
                                  e.preventDefault();
                                  handleSearch();
                                }
                              }}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        hidden={searchParam == ""}
                                        size="small"
                                        onClick={() => {
                                            setInputText("");
                                            handleSearchParam("");
                                        }}
                                        edge="end"
                                    >
                                        <CloseOutlinedIcon />
                                    </IconButton>
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => handleSearch()}
                                        edge="end"
                                        size="small"
                                    >
                                        <SearchOutlinedIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="label">{i18n.t("ticketManagement.filters.connection")}</Typography>
                    <QueueSelectConnection
                        selecteds={selectedsConnectionsAndQueues}
                        onSelected={(response) => onSelectConnectionsAndQueues(response)}
                        isCollapsed={true}
                        userId={user?.id || undefined}
                        className={classes.connectionFilter}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MultiSelect
                        title={<Typography>{i18n.t("ticketManagement.filters.tag")}</Typography>}
                        displayText={i18n.t("ticketManagement.filters.tagSelect")}
                        name="tManagementFilterTag"
                        key="tManagementFilterTag"
                        disabled={false}
                        options={Array.isArray(tags) ? tags.map((tag) => { return { key: tag.id, value: tag.name, disabled: false } }) : []}
                        onSelected={(options) => onSelectedTags(options)}
                        selecteds={selectedTags}
                        className={classes.multiSelectFilter}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MultiSelect
                        title={<Typography>{i18n.t("ticketManagement.filters.ticketStatus")}</Typography>}
                        displayText={i18n.t("ticketManagement.filters.ticketStatusSelect")}
                        name="tManagementFilterTicketStatus"
                        key="tManagementFilterTicketStatus"
                        disabled={false}
                        options={Array.isArray(ticketStatus) ? ticketStatus.map((ts) => { return { key: ts.key, value: ts.value, disabled: false } }) : []}
                        onSelected={(options) => onSelectTicketStatus(options)}
                        selecteds={selectedTicketStatus}
                        className={classes.multiSelectFilter}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MultiSelect
                        title={<Typography>{i18n.t("ticketManagement.filters.userStatus")}</Typography>}
                        displayText={i18n.t("ticketManagement.filters.userStatusSelect")}
                        name="tManagementFilterUserStatus"
                        key="tManagementFilterUserStatus"
                        disabled={false}
                        options={Array.isArray(userStatus) ? userStatus.map((usr) => { return { key: usr.key, value: usr.value, disabled: false } }) : []}
                        onSelected={(options) => onSelectedUserStatus(options)}
                        selecteds={selectedUserStatus}
                        className={classes.multiSelectFilter}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MultiSelect
                        title={<Typography>{i18n.t("ticketManagement.filters.assigneds")}</Typography>}
                        displayText={i18n.t("ticketManagement.filters.assignedsSelect")}
                        name="tManagementFilterAssigneds"
                        key="tManagementFilterAssigneds"
                        disabled={false}
                        options={Array.isArray(assigneds) ? assigneds.map((ass) => { return { key: ass.key, value: ass.value, disabled: false } }) : []}
                        onSelected={(options) => onSelectAssigned(options)}
                        selecteds={selectedAssigned}
                        className={classes.multiSelectFilter}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MultiSelect
                        title={<Typography>{i18n.t("ticketManagement.filters.user")}</Typography>}
                        displayText={i18n.t("ticketManagement.filters.userSelect")}
                        name="tManagementFilterUser"
                        key="tManagementFilterUser"
                        disabled={false}
                        options={Array.isArray(users) ? users.map((usr) => { return { key: usr.id, value: usr.name, customValue: isOnline(usr), disabled: !usr.status } }) : []}
                        onSelected={(options) => onSelectedUsers(options)}
                        selecteds={selectedUsers}
                        className={classes.multiSelectFilter}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default TicketManagementFilters;